import { render, staticRenderFns } from "./CoursewareContentPermissions.vue?vue&type=template&id=26adb8c6&"
import script from "./CoursewareContentPermissions.vue?vue&type=script&lang=js&"
export * from "./CoursewareContentPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports